import React from 'react';
import { getFlagByAlpha3 } from '../../utils/tkdCountries';

/**
 * Mostra la bandiera emoji corrispondente al codice alpha3 della nazione.
 * @param {string} nat  — codice ISO 3 (es. 'ITA', 'KOR')
 * @param {number} size — dimensione font in px (opzionale, default: ereditato)
 */
function Flag({ nat, size }) {
  const flag = getFlagByAlpha3(nat);
  if (!flag) return null;

  return (
    <span style={{
      fontSize:    size ? size : undefined,
      marginRight: size ? 6 : 4,
      lineHeight:  1,
      flexShrink:  0,
    }}>
      {flag}
    </span>
  );
}

export default Flag;
